import { LocalStorage } from "./LocalStorage";

export class Faq {
  constructor(id, title, type, content, createdAt, updatedAt) {
    this.id = id;
    this.title = title;
    this.type = type;
    this.content = content;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      const rawTitle = input[this.FAQ_ATTRIBUTE.TITLE];
      const rawContent = input[this.FAQ_ATTRIBUTE.CONTENT];
      return new Faq(
        input[this.FAQ_ATTRIBUTE.ID],
        typeof rawTitle === "object" ? rawTitle[LocalStorage.getLanguage()] : rawTitle,
        input[this.FAQ_ATTRIBUTE.TYPE],
        typeof rawContent === "object" ? rawContent[LocalStorage.getLanguage()] : rawContent,
        input[this.FAQ_ATTRIBUTE.CREATED_AT],
        input[this.FAQ_ATTRIBUTE.UPDATED_AT]
      )
    }
    return new Faq();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Faq.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Faq.fromApiObject(input)];
    }

    return [];
  }

  static FAQ_ATTRIBUTE = {
    ID: "id",
    TITLE: "title",
    TYPE: "type",
    CONTENT: "content",
    CREATED_AT: "created_at",
    UPDATED_AT: "updated_at"
  }

  genBox(index) {
    const html = `
      <div class="faq-item item" data-idx="${index}">
        <div class="border-box">
          <div class="title-box">
            <div class="arrow"></div>
            <div class="title">${index ? index + ". " : ""}${this.title}</div>
          </div>
          <div class="content fr-view">
            ${this.content}
          </div>
        </div>
      </div>
    `;
    return html;
  }
}